'use client';

import type { DetailContentInfo } from '__generated__/api/unauth';
import { EditorViewer } from '@common/components/organism/EditorViewer';

import { Image } from '@/components/client';

//* youtube embed url 이 아닐 경우 embed url 로 변환
const getYoutubeEmbedUrl = (url: string): string => {
  const regex =
    /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/;
  const match = url.match(regex);
  if (match && match[1]) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }

  return '';
};

interface ContentsProps {
  detailContentInfoList: DetailContentInfo[];
}

export const Contents = ({ detailContentInfoList }: ContentsProps) => {
  return (
    <section className="relative flex flex-col overflow-y-hidden">
      {/** 수정시 웰로 답례품 상세에서도 동일하게 수정 필요 */}
      {detailContentInfoList.map(
        (
          {
            contentType: contentType,
            contentUrl: contentUrl,
            description,
            autoplayYN: autoplayYN,
          },
          index,
        ) => {
          switch (contentType) {
            case 'IMAGE':
              return (
                <Image
                  key={index}
                  src={contentUrl}
                  alt={description ?? '상품 상세'}
                  width={850}
                  height={600}
                  className="w-full"
                  loading="eager"
                  sizes="(max-width: 768px) 100vw, 850px"
                />
              );
            case 'VIDEO': {
              const embedUrl = getYoutubeEmbedUrl(contentUrl);
              if (!embedUrl) return '';
              //* autoplayYN이 true면 자동재생 옵션 추가
              const autoplayParam = autoplayYN ? '?autoplay=1' : '';

              return (
                <iframe
                  width="100%"
                  height="500"
                  src={embedUrl + autoplayParam}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="YouTube video"
                  key={index}
                />
              );
            }
            case 'HTML':
              return <EditorViewer content={contentUrl} key={index} />;
          }
        },
      )}
    </section>
  );
};
